import React from 'react';
import { useAppSelector } from '../../store';
import CusLabelSelect from '../material-ui/CusLabelSelect';

export default function LanguageSelect({
  id,
  hideLabel,
  label = 'Lang',
  value,
  setValue,
  isRow,
  isVerySmall,
  isAllLanguages,
  toolTipText,
  disabled
}) {
  const languages = useAppSelector((state) => state.info.casinoLanguages);

  const languageOptions = languages.map((el) => ({ label: el.label, value: el.lang }));

  if (isAllLanguages) languageOptions.unshift({ label: 'All languages', value: 'all' });

  return (
    <CusLabelSelect
      id={id}
      label={hideLabel ? undefined : label}
      options={languageOptions}
      value={value}
      onChange={setValue}
      isRow={isRow}
      isVerySmall={isVerySmall}
      disabled={disabled}
      toolTipText={toolTipText}
    />
  );
}
